export default __webpack_public_path__ + "static/media/logo-live.580edf70.svg";